import { RefObject } from "react";

export const CARD_WIDTH = 0;
export const CARDS_VISIBLE = 4;
export const GAP = 0;

export const getGapBetweenCards = (refCards: RefObject<HTMLDivElement>, cardClassName: string) => {
  let gap = GAP;
  let cardWidth = CARD_WIDTH;

  const cardsDiv = refCards.current?.getElementsByClassName(cardClassName);
  if (cardsDiv && cardsDiv.length > 0) {
    const firstCard = cardsDiv[0] as HTMLAnchorElement;
    gap = Number(getComputedStyle(firstCard).marginRight.replace("px", ""));

    cardWidth = Math.round(Number(getComputedStyle(firstCard).width.replace("px", "")));

    if (cardWidth + gap) {
      return cardWidth + gap;
    }
  }

  return CARD_WIDTH + GAP;
};

export const getCardWidth = (refCards: RefObject<HTMLDivElement>, cardClassName: string) => {
  return getGapBetweenCards(refCards, cardClassName);
};

export const isCardVisible = (carousel: HTMLElement, card: HTMLElement): boolean => {
  const slice = {
    initial: carousel.getBoundingClientRect().left,
    end: carousel.getBoundingClientRect().right,
  };

  const { left, right } = card.getBoundingClientRect();
  const isVisibleOnMarginLeft = left >= slice.initial;
  const isVisibleOnMarginRight = right <= slice.end;

  return isVisibleOnMarginLeft && isVisibleOnMarginRight;
};

export function getVisibleCards(refCards: HTMLDivElement, cardClassName: string): number {
  const cards = refCards.getElementsByClassName(cardClassName);
  let visibleCards = 0;

  if (cards && refCards) {
    Array.from(cards).forEach((card) => {
      if (isCardVisible(refCards, card as HTMLDivElement)) {
        visibleCards += 1;
      }
    });
  }

  return visibleCards;
}

export const checkScrollLimit = (
  cardWidth: number,
  scrollX: number,
  cardAmount: number,
  cardsInView: number,
): { prev: boolean; next: boolean } => {
  const limitScroll = cardWidth * cardAmount;
  const currentScrollX = cardWidth * cardsInView + scrollX;
  return { prev: scrollX === 0, next: currentScrollX >= limitScroll };
};
